/* ==========================================================================
   Select > Config
   ========================================================================== */

const config = {
    component: 'Select',
    init: true,
    domEvents: true,
    autoStore: true,
    css: {
        valid: 'is-valid',
        error: 'has-error',
        active: 'is-active',
        hidden: 'is-hidden',
        hasChoices: 'has-choices',
        withBorder: 'select--with-border',
        withLabel: 'select--with-label',
        multiple: 'select--multiple'
    },
    isActive: false,
    onChange: [],
    enableClick: false,
    choices: {
        searchEnabled: true,
        renderChoiceLimit: -1 /* limit the quantity of options shown, -1 infinite */,
        searchResultLimit: 5 /* Limit the quantity of options to show on seach, -1 infinite */,
        removeItemButton: false /* for multiple select true */,
        placeholderValue: 'Type to search...',
        searchPlaceholderValue: 'Type to search...',
        loadingText: 'Loading...',
        noResultsText: 'No results found',
        noChoicesText: 'No choices to choose from',
        itemSelectText: 'Press to select',
        sortFn: () => {}
    },
    /**
     * Callback fired when the select opens
     * @param {object} select
     */
    onOpen: () => {}
};

module.exports = () => config;
